import axios from 'axios';
import { USER_LOGIN, USER_LOGOUT } from '../reducers/auth';
import config from '../config';

export function setCurrentUser(user: any) {
    return {
        type: USER_LOGIN,
        user
    };
}

export function loginRequest(data: any) {
    return (dispatch: any) => {
        return axios.post(`${config.host}/user/login`, data).then(res => {
            if (res.data.status == "success") {
                localStorage.setItem('token', res.data.token);
                localStorage.setItem('user', JSON.stringify(res.data.user));
                axios.defaults.headers.common['Authorization'] = "Bearer " + res.data.token;
                dispatch(setCurrentUser(res.data.user));
            } else {

            }

            return res;
        });
    }
}

export function signupRequest(data: FormData) {
    return (dispatch: any) => {
        return axios.post(`${config.host}/user/signup`, data, {
            headers: {
                'content-type': `multipart/form-data`
            }
        }).then(res => {
            if (res.data.status == "success") {
                localStorage.setItem('token', res.data.token);
                localStorage.setItem('user', JSON.stringify(res.data.user));
                axios.defaults.headers.common['Authorization'] = "Bearer " + res.data.token;
                dispatch(setCurrentUser(res.data.user));
            } else {

            }

            return res;
        });
    }
}
export function facebookRequest(data: any) {
    return (dispatch: any) => {
        return axios.post(`${config.host}/user/facebook`, data).then(res => {
            if (res.data.status == "success") {
                localStorage.setItem('token', res.data.token);
                localStorage.setItem('user', JSON.stringify(res.data.user));
                axios.defaults.headers.common['Authorization'] = "Bearer " + res.data.token;
                dispatch(setCurrentUser(res.data.user));
            } else {

            }

            return res;
        });
    }
}

export function profileRequest(data: FormData) {
    return (dispatch: any) => {
        return axios.post(`${config.host}/user/profile`, data, {
            headers: {
                'content-type': `multipart/form-data`
            }
        }).then(res => {
            if (res.data.status == "success") {
                localStorage.setItem('user', JSON.stringify(res.data.user));
                dispatch(setCurrentUser(res.data.user));
            } else {

            }

            return res;
        });
    }
}

function logoutAction() {
    return {
        type: USER_LOGOUT
    };
}

export function logout() {
    return (dispatch: any) => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        dispatch(logoutAction());
    }
}